import { render, staticRenderFns } from "./ParticipantDetail.vue?vue&type=template&id=3b89cd57&"
import script from "./ParticipantDetail.vue?vue&type=script&lang=ts&"
export * from "./ParticipantDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports